var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isPopFrame
    ? _c(
        "div",
        {
          staticClass: "closeModalBtn",
          on: {
            click: function ($event) {
              return _vm.closeModalFunc(null)
            },
          },
        },
        [_c("i", { staticClass: "iconfont yyq-icon-close_1" })]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }